import { create, show, useModal } from "@ebay/nice-modal-react";

import { ConfettiColored } from "components/icons/generated";
import Box from "ds/components/Box";
import Button from "ds/components/Button";
import Icon from "ds/components/Icon";
import Link from "ds/components/Link";
import Modal from "ds/components/Modal";
import ModalContent from "ds/components/Modal/Content";
import Typography from "ds/components/Typography";
import TypographyHeading from "ds/components/Typography/Heading";

import { UserManagementActivationStatus } from "../../types";

type UsersInviteSuccessModalProps = {
  activationStatus: UserManagementActivationStatus;
};

const UsersInviteSuccessModal = create(function UsersInviteSuccessModal({
  activationStatus,
}: UsersInviteSuccessModalProps) {
  const userManagementActive = activationStatus === UserManagementActivationStatus.ACTIVE;
  const modal = useModal();

  return (
    <Modal isOpen={modal.visible} onExit={modal.remove}>
      <ModalContent>
        <Box direction="column" align="center" justify="center" padding="medium" gap="x-large">
          <Icon src={ConfettiColored} size="xx-large" />
          <Box direction="column" align="center" justify="center" gap="medium">
            <TypographyHeading variant="p-t5">
              {!userManagementActive && "Invitation prepared"}
              {userManagementActive && "Invite sent!"}
            </TypographyHeading>
            <Typography variant="p-body3" tag="p" align="center">
              {!userManagementActive && (
                <>
                  Your invitation will be sent when you enable Identity Access
                  <br /> Management in{" "}
                  <Link onPress={modal.hide} href="/settings/management-strategy">
                    Management strategy
                  </Link>
                  .
                </>
              )}
              {userManagementActive && (
                <>
                  An invitation has been sent to the user's email address. They'll be able to join
                  and start collaborating once they accept.
                </>
              )}
            </Typography>
          </Box>
          <Button variant="primary" onPress={modal.hide}>
            Okay
          </Button>
        </Box>
      </ModalContent>
    </Modal>
  );
});

export const showInviteSuccessModal = (props: UsersInviteSuccessModalProps) =>
  show(UsersInviteSuccessModal, props);
